export  class PaymentSummaryResponse {
  constructor(
    public activityCd: string,
    public paymentRequest: string,
    public activityBeginDt: any,
    public activityEndDt: any,
    public paymentReqStatus: string,
    public entitlementCd: string,
    public program: string,
	  public wpPaymentId: number,
	  public wpPersonId: number,
	  public wpReferralId:number,
) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/payment-summary-response.model.ts